import { researchRoutes } from "./research-routes";

export default (router: any) => {
  researchRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
